import { KnowledgeSourceTraining } from '@vendasta/embeddings';
import { isTrainingFinished } from '../../ai-knowledge-util';

export interface TrainingProgressConfig {
  /** The training info from the knowledge source */
  trainingInfo: KnowledgeSourceTraining | null;
  /** Whether to delay hiding the progress screen after training is complete */
  delayProgressScreenClosure?: boolean;
  /** For website sources: number of pages enabled for training (when > 0, shows page count instead of percentage) */
  trainingEnabledPageCount?: number;
}
export function shouldShowTrainingProgress(config: TrainingProgressConfig, shouldShowDone: boolean): boolean {
  return (
    shouldShowDone ||
    (config.trainingInfo && !isTrainingFinished(config.trainingInfo)) ||
    config.delayProgressScreenClosure === true
  );
}
